import { Variants } from "framer-motion";

export const fadeUp: Variants = {
    hidden: { opacity: 0, y: 30 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay, ease: "easeOut" },
    }),
};

export const fadeDown: Variants = {
    hidden: { opacity: 0, y: -30 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay, ease: "easeOut" },
    }),
};

export const fadeLeft: Variants = {
    hidden: { opacity: 0, x: -40 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.5, delay, ease: "easeOut" },
    }),
};

export const fadeRight: Variants = {
    hidden: { opacity: 0, x: 40 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.5, delay, ease: "easeOut" },
    }),
};

export const fadeIn: Variants = {
    hidden: { opacity: 0 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        transition: { duration: 0.4, delay, ease: "easeOut" },
    }),
};

export const popIn: Variants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.4, ease: [0.34, 1.56, 0.64, 1] },
    },
};

export const bounceIn: Variants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { type: "spring", stiffness: 300, damping: 20 },
    },
};

export const scaleIn: Variants = {
    hidden: { opacity: 0, scale: 0 },
    visible: (delay: number = 0) => ({
        opacity: 1,
        scale: 1,
        transition: { duration: 0.4, delay, ease: [0.22, 1, 0.36, 1] },
    }),
};

export const stagger = (staggerTime: number = 0.1): Variants => ({
    hidden: {},
    visible: {
        transition: { staggerChildren: staggerTime },
    },
});

export const staggerWithDelay = (staggerTime: number = 0.1, delayChildren: number = 0.2): Variants => ({
    hidden: {},
    visible: {
        transition: { staggerChildren: staggerTime, delayChildren },
    },
});

export const revealUp: Variants = {
    hidden: {
        opacity: 0,
        y: "100%",
        clipPath: "inset(100% 0 0 0)",
    },
    visible: (delay: number = 0) => ({
        opacity: 1,
        y: 0,
        clipPath: "inset(0% 0 0 0)",
        transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
    }),
};

export const slideIn: Variants = {
    hidden: { x: "-100%", opacity: 0 },
    visible: {
        x: 0,
        opacity: 1,
        transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
    },
};

export const hoverLift = {
    y: -6,
    transition: { duration: 0.25 },
};

export const hoverScale = {
    scale: 1.02,
    transition: { duration: 0.25 },
};

export const hoverLiftScale = {
    y: -6,
    scale: 1.02,
    transition: { duration: 0.25 },
};
